(function () {
  'use strict';

  var EXTERNAL_SEARCH_SELECTORS = [
    'shopify-search-autocomplete',
    '.shopify-search-autocomplete',
    '[class*="shopify-search-autocomplete"]',
    '[class*="ShopifySearchAutocomplete"]',
    '[data-shopify-search-autocomplete]',
    'predictive-search',
    'div.snize-ac-results',
    '.snize-ac-results'
  ].join(',');

  var COLLECTIONS_SHOWN = 2;

  function getConfig(root) {
    var el = root.querySelector('[data-sm-search-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  /* ---- Currency handling (from dev update) ---- */

  function getActiveCurrency(fallback) {
    if (window.Currency && Currency.currentCurrency) return Currency.currentCurrency;
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return fallback || '';
  }

  function getMoneyFormat(currencyCode, fallbackFormat) {
    var key = (window.Currency && Currency.format) || 'money_format';
    if (currencyCode && window.Currency && Currency.moneyFormats && Currency.moneyFormats[currencyCode]) {
      return (
        Currency.moneyFormats[currencyCode][key] ||
        Currency.moneyFormats[currencyCode].money_format ||
        fallbackFormat
      );
    }
    return fallbackFormat || (typeof window.default_currency_format !== 'undefined' ? window.default_currency_format : null);
  }

  function formatPrice(price, shopCurrency, moneyFormat) {
    if (price == null || price === '') return '';
    if (typeof price === 'object') {
      if (price.amount != null) price = price.amount;
      else if (price.price != null) price = price.price;
    }

    var amount = parseFloat(String(price).replace(/,/g, ''));
    if (isNaN(amount)) return '';

    var fromCurrency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) || shopCurrency;
    var cents = Math.round(amount * 100);
    var format = getMoneyFormat(fromCurrency, moneyFormat);
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && format) {
      return Shopify.formatMoney(cents, format);
    }

    return (fromCurrency ? fromCurrency + ' ' : '$') + amount.toFixed(2);
  }

  function applySearchCurrency(root, fromCurrency) {
    if (!root || typeof Currency === 'undefined' || typeof Currency.convertAll !== 'function') return;

    var source = fromCurrency || (window.Shopify && Shopify.currency && Shopify.currency.active);
    var current = getActiveCurrency(source);
    if (!source) return;

    var moneyEls = root.querySelectorAll('span.money');
    for (var i = 0; i < moneyEls.length; i++) {
      var el = moneyEls[i];
      var attr = 'data-currency-' + source;
      if (!el.getAttribute(attr)) {
        el.setAttribute(attr, el.innerHTML);
      }
    }

    if (current && source !== current) {
      Currency.convertAll(source, current);
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---- Collection cards ---- */

  function collectionImageUrl(collection) {
    if (collection.featured_image && collection.featured_image.url) {
      return collection.featured_image.url;
    }
    if (collection.image && collection.image.url) {
      return collection.image.url;
    }
    if (typeof collection.image === 'string') {
      return collection.image;
    }
    return '';
  }

  function buildCollectionCard(collection, label) {
    var imageUrl = collectionImageUrl(collection);

    var imageHtml = imageUrl
      ? '<span class="sm-search-collection__media">' +
        '<img src="' + escapeHtml(imageUrl) + '" alt="" loading="lazy">' +
        '</span>'
      : '';

    return (
      '<a class="sm-search-collection" href="' + escapeHtml(collection.url) + '">' +
        imageHtml +
        '<span class="sm-search-collection__text">' +
          '<span class="sm-search-collection__title">' + escapeHtml(collection.title) + '</span>' +
          '<span class="sm-search-collection__meta">' + escapeHtml(label) + '</span>' +
        '</span>' +
      '</a>'
    );
  }

  /* ---- Product tiles ---- */

  function buildProductTile(product) {
    var imageUrl = '';
    if (product.featured_image && product.featured_image.url) {
      imageUrl = product.featured_image.url;
    } else if (product.image) {
      imageUrl = product.image;
    }

    var imageHtml = imageUrl
      ? '<img class="sm-product-tile__image sm-product-tile__image--primary" src="' +
        escapeHtml(imageUrl) +
        '" alt="' +
        escapeHtml(product.title) +
        '" loading="lazy">'
      : '';

    var vendorHtml = product.vendor
      ? '<p class="sm-product-tile__vendor">' + escapeHtml(product.vendor) + '</p>'
      : '';

    var typeHtml = product.type
      ? '<p class="sm-product-tile__type">' + escapeHtml(product.type) + '</p>'
      : '';

    var priceHtml = '';
    var formattedPrice = product.price_html || formatPrice(product.price, product.shopCurrency, product.moneyFormat);
    if (formattedPrice) {
      priceHtml =
        '<p class="sm-product-tile__price"><span class="money">' +
        escapeHtml(formattedPrice) +
        '</span></p>';
    }

    return (
      '<div class="sm-search-dropdown__slide">' +
        '<div class="sm-product-tile">' +
          '<div class="sm-product-tile__media">' +
            '<a href="' + escapeHtml(product.url) + '" class="sm-product-tile__image-link">' +
              '<span class="sm-product-tile__image-frame">' +
                '<span class="sm-product-tile__image-stack">' + imageHtml + '</span>' +
              '</span>' +
            '</a>' +
          '</div>' +
          '<div class="sm-product-tile__info">' +
            vendorHtml +
            '<p class="sm-product-tile__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></p>' +
            typeHtml +
            priceHtml +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function closeNavDrawer() {
    if (window.timber && timber.LeftDrawer && timber.LeftDrawer.drawerIsOpen) {
      timber.LeftDrawer.close();
    }
  }

  function initSearchArea(searchArea) {
    if (!searchArea || searchArea.dataset.smSearchInit) return;

    var isMobile = searchArea.dataset.smSearchMobile === 'true';
    var desktopHeader = document.querySelector('[data-sm-header]');
    var overlay = isMobile ? null : document.querySelector('[data-sm-header-overlay]');

    var config = getConfig(searchArea);
    var input = searchArea.querySelector('[data-sm-search-input]');
    var queryInput = searchArea.querySelector('[data-sm-search-query]');
    var form = searchArea.querySelector('[data-sm-search-form]');
    var dropdown = searchArea.querySelector('[data-sm-search-dropdown]');
    var trendingList = searchArea.querySelector('[data-sm-search-trending]');
    var trendingHeading = searchArea.querySelector('[data-sm-search-trending-heading]');
    var collectionsRow = searchArea.querySelector('[data-sm-search-collections]');
    var productsTrack = searchArea.querySelector('[data-sm-search-products]');
    var resultsHeading = searchArea.querySelector('[data-sm-search-results-heading]');
    var emptyState = searchArea.querySelector('[data-sm-search-empty]');
    var prevBtn = searchArea.querySelector('[data-sm-search-prev]');
    var nextBtn = searchArea.querySelector('[data-sm-search-next]');
    var closeBtn = searchArea.querySelector('[data-sm-mobile-search-close]');

    if (!input || !dropdown || !productsTrack) return;
    searchArea.dataset.smSearchInit = 'true';

    /* The overlay has to escape the drawer's transform for position:fixed
       to work. Done once here at load, never during a tap. */
    if (isMobile && searchArea.parentNode !== document.body) {
      document.body.appendChild(searchArea);
    }

    var defaultSlidesHtml = '';
    var cachedPopularQueries = (config.trendingLinks || []).slice();
    var debounceTimer = null;
    var currentAbort = null;
    var isOpen = false;
    var observer = null;
    var $ = window.jQuery;
    var payloadCurrency = config.shopCurrency;

    function containsSearchTarget(target) {
      return searchArea.contains(target);
    }

    function hideExternalSearchAutocomplete() {
      document.querySelectorAll(EXTERNAL_SEARCH_SELECTORS).forEach(function (el) {
        if (containsSearchTarget(el)) return;
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.setAttribute('aria-hidden', 'true');
      });
    }

    function syncQueryInput() {
      if (queryInput) queryInput.value = input.value;
    }

    function startExternalSearchObserver() {
      hideExternalSearchAutocomplete();
      if (observer) return;
      observer = new MutationObserver(hideExternalSearchAutocomplete);
      observer.observe(document.body, { childList: true, subtree: true });
    }

    function stopExternalSearchObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    function destroySlider() {
      if (!$ || !$.fn.owlCarousel) return;
      var $track = $(productsTrack);
      if ($track.hasClass('owl-loaded')) {
        $track.trigger('destroy.owl.carousel');
        $track.removeClass('owl-carousel owl-loaded owl-drag owl-grab owl-theme');
      }
    }

    function updateArrows(needsSlider) {
      if (!prevBtn || !nextBtn) return;
      prevBtn.hidden = !needsSlider;
      nextBtn.hidden = !needsSlider;
    }

    function initSlider() {
      if (isMobile) {
        destroySlider();
        updateArrows(false);
        return;
      }

      if (!$ || !$.fn.owlCarousel) {
        updateArrows(false);
        return;
      }

      var $track = $(productsTrack);
      var slideCount = $track.children().length;
      if (slideCount <= 3) {
        destroySlider();
        updateArrows(false);
        return;
      }

      if (!$track.hasClass('owl-loaded')) {
        $track.addClass('owl-carousel').owlCarousel({
          items: 3,
          loop: false,
          nav: false,
          dots: false,
          margin: 20,
          mouseDrag: true,
          touchDrag: true,
          pullDrag: true,
          responsive: {
            990: { items: 3, margin: 20 },
            1200: { items: 4, margin: 20 }
          }
        });

        prevBtn.onclick = function () {
          $track.trigger('prev.owl.carousel');
        };
        nextBtn.onclick = function () {
          $track.trigger('next.owl.carousel');
        };
      } else {
        $track.trigger('refresh.owl.carousel');
      }

      updateArrows(true);
    }

    function hasActiveQuery() {
      return input.value.trim().length > 0;
    }

    function renderTrendingList(items, heading) {
      if (!trendingList) return;

      if (trendingHeading && heading) {
        trendingHeading.textContent = heading;
      }

      if (!items || !items.length) {
        trendingList.innerHTML = '';
        return;
      }

      trendingList.innerHTML = items
        .map(function (item) {
          var url = item.url || (config.searchUrl + '?q=' + encodeURIComponent(item.text));
          var itemClass = item.isCollection ? ' class="sm-search-dropdown__trending-collection"' : '';
          return (
            '<li' + itemClass + '><a href="' + escapeHtml(url) + '">' + escapeHtml(item.text) + '</a></li>'
          );
        })
        .join('');
    }

    function cachePopularQueries(queries) {
      if (!queries || !queries.length) return;
      cachedPopularQueries = queries.map(function (query) {
        return { text: query.text, url: query.url };
      });
    }

    function showPopularTrending() {
      renderTrendingList(
        cachedPopularQueries,
        config.trendingHeading || 'Trending Right Now'
      );
    }

    function hideCollections() {
      if (!collectionsRow) return;
      collectionsRow.innerHTML = '';
      collectionsRow.hidden = true;
    }

    function showCollections(collections) {
      if (!collectionsRow) return;

      if (!collections || !collections.length) {
        hideCollections();
        return;
      }

      var label = config.collectionLabel || 'Shop all';

      collectionsRow.innerHTML = collections
        .slice(0, COLLECTIONS_SHOWN)
        .map(function (collection) {
          return buildCollectionCard(collection, label);
        })
        .join('');

      collectionsRow.hidden = false;
    }

    function fetchPopularQueries() {
      /* A configured Trending searches menu wins. Shopify's popular
         queries are only the fallback when no menu is set. */
      if (cachedPopularQueries.length) {
        showPopularTrending();
        return Promise.resolve();
      }

      var base = config.predictiveSearchUrl || '/search/suggest';
      var urls = [
        base + '.json?q=&resources[type]=query&resources[limit]=8&resources[options][unavailable_products]=hide',
        base + '.json?q=a&resources[type]=query&resources[limit]=8&resources[options][unavailable_products]=hide'
      ];

      function tryFetch(index) {
        if (index >= urls.length) {
          showPopularTrending();
          return Promise.resolve();
        }

        return fetch(urls[index])
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (data) {
            var queries =
              data &&
              data.resources &&
              data.resources.results &&
              data.resources.results.queries;

            if (queries && queries.length) {
              cachePopularQueries(queries);
              showPopularTrending();
              return;
            }

            return tryFetch(index + 1);
          })
          .catch(function () {
            return tryFetch(index + 1);
          });
      }

      showPopularTrending();
      return tryFetch(0);
    }

    /* ---- Best sellers (from dev update) ---- */

    function buildProductTileFromCollectionProduct(product) {
      var url = '/products/' + product.handle;
      var imageUrl = product.images && product.images.length ? product.images[0].src : '';
      var price = null;

      if (product.variants && product.variants.length) {
        price = product.variants[0].price;
      }

      return buildProductTile({
        url: url,
        title: product.title,
        vendor: product.vendor,
        type: product.product_type,
        featured_image: imageUrl ? { url: imageUrl } : null,
        image: imageUrl,
        price: price,
        price_html: product.price_html,
        shopCurrency: payloadCurrency,
        moneyFormat: config.moneyFormat
      });
    }

    function parseJsonObject(text) {
      if (!text) return null;
      var start = text.indexOf('{');
      if (start === -1) return null;
      try {
        return JSON.parse(text.slice(start));
      } catch (e) {
        return null;
      }
    }

    function fetchCollectionProducts(handle) {
      var limit = config.productsLimit || 12;
      var url =
        '/collections/' +
        encodeURIComponent(handle) +
        '?view=sm-search-products&sort_by=best-selling';

      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.text() : null;
        })
        .then(function (text) {
          var data = parseJsonObject(text);
          if (data && data.currency) payloadCurrency = data.currency;
          if (data && data.products && data.products.length) {
            return data.products.slice(0, limit);
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }

    function getBestsellerHandles() {
      var handles = [];
      var preferred = config.bestsellersHandle || 'all';

      [preferred, 'all'].forEach(function (handle) {
        if (handle && handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
      });

      return handles;
    }

    function loadBestsellers() {
      var handles = getBestsellerHandles();
      var index = 0;

      function tryNext() {
        if (index >= handles.length) {
          return Promise.resolve();
        }

        var handle = handles[index];
        index += 1;

        return fetchCollectionProducts(handle).then(function (products) {
          if (products && products.length) {
            defaultSlidesHtml = products.map(buildProductTileFromCollectionProduct).join('');
            if (!hasActiveQuery() && isOpen) {
              showIdleState();
            }
            return;
          }
          return tryNext();
        });
      }

      return tryNext();
    }

    function showIdleState() {
      dropdown.dataset.smSearchMode = 'idle';
      showPopularTrending();
      hideCollections();
      destroySlider();
      productsTrack.innerHTML = defaultSlidesHtml;
      if (resultsHeading) {
        resultsHeading.textContent = config.bestsellersHeading || 'You might like these best sellers';
      }
      if (emptyState) emptyState.hidden = true;
      applySearchCurrency(productsTrack, payloadCurrency);
      initSlider();
    }

    function showSearchResults(products) {
      dropdown.dataset.smSearchMode = 'search';
      destroySlider();

      if (resultsHeading) {
        resultsHeading.textContent = config.resultsHeading || 'Search results';
      }

      if (!products || !products.length) {
        productsTrack.innerHTML = '';
        if (emptyState) emptyState.hidden = false;
        updateArrows(false);
        return;
      }

      if (emptyState) emptyState.hidden = true;
      productsTrack.innerHTML = products.map(function (product) {
        product.shopCurrency = payloadCurrency;
        product.moneyFormat = config.moneyFormat;
        return buildProductTile(product);
      }).join('');
      applySearchCurrency(
        productsTrack,
        (window.Shopify && Shopify.currency && Shopify.currency.active) || payloadCurrency
      );
      initSlider();
    }

    function fetchResults(query) {
      if (currentAbort) currentAbort.abort();

      var url =
        (config.predictiveSearchUrl || '/search/suggest') +
        '.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product,collection,query&resources[limit]=' +
        (config.productsLimit || 12) +
        '&resources[limit_scope]=each&resources[options][unavailable_products]=hide';

      currentAbort = new AbortController();

      fetch(url, { signal: currentAbort.signal })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var results = (data.resources && data.resources.results) || {};
          var queries = results.queries || [];
          var products = results.products || [];
          var collections = results.collections || [];

          var suggestions = collections.slice(0, COLLECTIONS_SHOWN).map(function (collection) {
            return { text: collection.title, url: collection.url, isCollection: true };
          });

          queries.forEach(function (item) {
            suggestions.push({ text: item.text, url: item.url });
          });

          if (suggestions.length) {
            renderTrendingList(
              suggestions,
              config.suggestionsHeading || 'Popular suggestions'
            );
          } else {
            showPopularTrending();
          }

          showCollections(collections);
          showSearchResults(products);
          hideExternalSearchAutocomplete();
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          hideCollections();
          loadBestsellers();
          showPopularTrending();
        })
        .finally(function () {
          currentAbort = null;
        });
    }

    function onInputChange() {
      var query = input.value.trim();
      hideExternalSearchAutocomplete();

      if (debounceTimer) clearTimeout(debounceTimer);

      debounceTimer = setTimeout(function () {
        if (query.length === 0) {
          showIdleState();
          loadBestsellers();
          return;
        }
        fetchResults(query);
      }, 220);
    }

    function openSearch() {
      if (isOpen) return;
      isOpen = true;
      searchArea.classList.add('is-search-open');
      document.body.classList.add('is-sm-search-open');
      dropdown.hidden = false;

      if (isMobile) {
        searchArea.hidden = false;
        document.body.classList.add('is-sm-mobile-search-open');
      } else {
        if (overlay) overlay.classList.add('is-visible');
        document.dispatchEvent(new CustomEvent('sm-header:close-nav'));
      }

      startExternalSearchObserver();
      showIdleState();
      fetchPopularQueries();
      loadBestsellers();
      hideExternalSearchAutocomplete();
    }

    function closeSearch() {
      if (!isOpen) return;
      isOpen = false;
      searchArea.classList.remove('is-search-open');

      if (!document.querySelector('[data-sm-search].is-search-open')) {
        document.body.classList.remove('is-sm-search-open');
      }

      dropdown.hidden = true;

      if (isMobile) {
        searchArea.hidden = true;
        document.body.classList.remove('is-sm-mobile-search-open');
      }

      stopExternalSearchObserver();

      if (
        overlay &&
        desktopHeader &&
        !desktopHeader.querySelector('.sm-header__nav-item.is-open') &&
        !document.querySelector('[data-sm-search].is-search-open')
      ) {
        overlay.classList.remove('is-visible');
      }
    }

    if (isMobile) {
      /* The whole open sequence runs synchronously inside the tap, which is
         what lets iOS bring up the keyboard. The drawer closes first,
         because Timber's close() blurs whatever is focused. */
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest && e.target.closest('[data-sm-mobile-search-open]');
        if (!trigger) return;
        e.preventDefault();
        closeNavDrawer();
        openSearch();
        input.focus({ preventScroll: true });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', closeSearch);
      }
    } else {
      input.addEventListener('focus', openSearch);
      input.addEventListener('click', openSearch);
    }

    input.addEventListener('input', function () {
      syncQueryInput();
      onInputChange();
    });

    if (form) {
      form.addEventListener('submit', function () {
        syncQueryInput();
        closeSearch();
      });
    }

    document.addEventListener('sm-header:close-search', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      if (e.target.closest && e.target.closest('[data-sm-mobile-search-open]')) return;
      if (containsSearchTarget(e.target)) return;
      closeSearch();
    });

    if (overlay) {
      overlay.addEventListener('click', closeSearch);
    }

    fetchPopularQueries();
    loadBestsellers();

    if (!isMobile) {
      window.smHeaderSearch = {
        close: closeSearch,
        isOpen: function () {
          return isOpen;
        }
      };
    }
  }

  function initSmHeaderSearch() {
    document.querySelectorAll('[data-sm-search]').forEach(initSearchArea);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmHeaderSearch);
  } else {
    initSmHeaderSearch();
  }

  document.addEventListener('shopify:section:load', initSmHeaderSearch);
})();